import {MousePosition} from "../PlannerContext";

export function isMousePositionInElement(mousePosition: MousePosition, element: HTMLElement): boolean {
    const {top, left, height, width} = element.getBoundingClientRect()
    return mousePosition.x >= left
        && mousePosition.x <= (left+width)
        && mousePosition.y >= top
        && mousePosition.y <= (top+height)
}
